export default {
  version: '1.0.0'
}



// WEBPACK FOOTER //
// ./src/config/config.base.js